class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* ===========================================================================
   Minicart scroll-lock fix (native Dawn drawer vs. Opus cart app)
   ---------------------------------------------------------------------------
   On this store the visible minicart is the Opus cart app (`.drawer-cd-up-app-*`),
   which manages its own scroll lock correctly. The native Dawn cart drawer is
   never the cart UI here (the cart icon opens Opus), but it still co-opens on
   Add-to-Cart and adds `overflow-hidden` to <body>. Because the shopper closes
   the Opus drawer (not the native one), the native drawer stays `active` and its
   `overflow-hidden` lock is never removed -> the whole page is left unscrollable
   until a refresh.

   Fix: whenever the native drawer is `active` but the Opus drawer is NOT visible
   (i.e. the real minicart is closed), close the native drawer, which removes the
   stray `overflow-hidden` lock. While Opus is open the lock is left untouched, so
   scrolling stays correctly locked behind the open minicart.
   =========================================================================== */
(function () {
  function nativeDrawer() {
    return document.querySelector('cart-drawer');
  }

  function opusDrawerVisible() {
    var els = document.querySelectorAll('[class*="drawer-cd-up-app"]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var s = getComputedStyle(el);
      if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) === 0) continue;
      var r = el.getBoundingClientRect();
      if (r.width > 0 && r.right > 5 && r.left < window.innerWidth - 5) return true;
    }
    return false;
  }

  function sync() {
    var cd = nativeDrawer();
    if (!cd || !cd.classList.contains('active')) return;
    if (opusDrawerVisible()) return; // real minicart is open; keep the lock
    if (typeof cd.close === 'function') {
      cd.close();
    } else {
      cd.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  }

  function init() {
    var cd = nativeDrawer();
    if (cd) {
      new MutationObserver(function () { setTimeout(sync, 60); })
        .observe(cd, { attributes: true, attributeFilter: ['class'] });
    }
    var opus = document.querySelector('[class*="drawer-cd-up-app"]');
    if (opus) {
      new MutationObserver(function () { setTimeout(sync, 60); })
        .observe(opus, { attributes: true, attributeFilter: ['class', 'style'] });
    }
    document.addEventListener('click', function () { setTimeout(sync, 150); }, true);
    document.addEventListener('keyup', function (e) { if (e.code === 'Escape') setTimeout(sync, 150); }, true);
    setInterval(function () {
      var d = nativeDrawer();
      if (d && d.classList.contains('active')) sync();
    }, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ===========================================================================
   International free-shipping tracker correction (Opus cart, Global-e sessions)
   ---------------------------------------------------------------------------
   The Opus cart's free-shipping progress tracker computes its own threshold
   (the native $70 USD value at a different FX rate), which does NOT match
   Global-e's banner threshold for international shoppers. For non-US sessions
   this keeps Opus's progress bar but corrects its numbers to Global-e's
   threshold, read straight from the GE banner, using the live presentment
   subtotal (/cart.js). Fail-safe: if it isn't an intl session, the tracker isn't
   present, or no positive GE threshold can be read, it leaves Opus's tracker
   untouched. Domestic (US) sessions are unaffected.
   =========================================================================== */
(function () {
  function isIntl() {
    return !!(window.Shopify && Shopify.country && Shopify.country !== 'US');
  }

  // Parse a localized amount, extracting just the numeric token first so a currency
  // prefix that contains its own separator (e.g. "Afl.130.00") can't corrupt it.
  // "₡31,805" -> 31805, "₡ 27.400,00" -> 27400, "Afl.130.00" -> 130, "Br2,743.14" -> 2743.14.
  function parseLocaleNumber(str) {
    var m = String(str).match(/\d[\d.,  ]*\d|\d/);
    if (!m) return NaN;
    var s = m[0].replace(/[  ]/g, '');
    var di = Math.max(s.lastIndexOf(','), s.lastIndexOf('.'));
    if (di === -1) return parseFloat(s);
    var after = s.slice(di + 1).replace(/\D/g, '');
    if (after.length === 3) return parseFloat(s.replace(/[.,]/g, '')); // grouping sep
    var decSep = s[di], thou = decSep === ',' ? '.' : ',';
    return parseFloat(s.split(thou).join('').replace(decSep, '.'));
  }

  // Read Global-e's free-shipping threshold from its banner text.
  function geThreshold() {
    var all = document.body.querySelectorAll('*');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (el.children.length) continue;
      var t = el.textContent;
      if (/free shipping to .+above/i.test(t)) {
        var m = t.match(/above\s*([^\n]+?)\s*$/i);
        if (m) return parseLocaleNumber(m[1]);
      }
    }
    return NaN;
  }

  // Infer a currency format from a sample amount string (handles "₡ 5.348,66",
  // "Br2,743.14", "€56,95", etc.).
  function inferFmt(sample) {
    var sym = (String(sample).match(/^[^\d-]*/) || [''])[0];
    var num = String(sample).slice(sym.length);
    var di = Math.max(num.lastIndexOf(','), num.lastIndexOf('.'));
    var f = { sym: sym, thou: '', dec: '', decimals: 0 };
    if (di > -1) {
      var after = num.slice(di + 1).replace(/\D/g, '');
      if (after.length <= 2) { f.dec = num[di]; f.decimals = after.length; f.thou = f.dec === ',' ? '.' : ','; }
      else { f.thou = num[di]; }
    }
    return f;
  }
  function fmt(amount, f) {
    var s = amount.toFixed(f.decimals || 0), p = s.split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.thou || '');
    return f.sym + (f.decimals ? p[0] + (f.dec || ',') + p[1] : p[0]);
  }

  // Matches a currency amount inside the tracker text (with optional symbol).
  var PRICE = /([^\d\sA-Za-z]\s?)?\d[\d.,]*\d/;
  var lastText = null;     // the text WE wrote
  var lastOpusText = null; // the Opus value we last replaced (prevents a redraw tug-of-war)
  var pending = false;

  function apply() {
    if (!isIntl() || pending) return;
    var rc = document.querySelector('.cd-rewards-container'); // Opus tracker block
    if (!rc) return;
    var rt = rc.querySelector('.rewards-text');
    if (rt) {
      var cur = rt.textContent;
      if (cur === lastText || cur === lastOpusText) return; // ours, or Opus re-asserting the same value
    }
    var threshold = geThreshold();
    if (!(threshold > 0)) return; // fail-safe: leave Opus tracker as-is
    pending = true;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var c = document.querySelector('.cd-rewards-container');
        if (!c) return;
        var t = c.querySelector('.rewards-text');
        var bar = c.querySelector('.cd-progress-bar');
        var subtotal = d.total_price / 100;
        var remaining = threshold - subtotal;
        var pct = Math.max(0, Math.min(100, subtotal / threshold * 100));
        if (bar) { var w = pct.toFixed(4) + '%'; if (bar.style.width !== w) bar.style.width = w; }
        if (t) {
          var cur2 = t.textContent;
          if (cur2 !== lastText) lastOpusText = cur2; // remember the Opus value we're replacing
          var tok = (cur2.match(PRICE) || [null])[0];
          var f = inferFmt(tok || '');
          var nt = remaining > 0
            ? (tok ? cur2.replace(tok, fmt(remaining, f)) : ('You are ' + fmt(remaining, f) + ' away from Free Shipping!'))
            : 'You’ve unlocked free shipping! 🎉';
          if (t.textContent !== nt) t.textContent = nt;
          lastText = nt;
        }
      })
      .catch(function () {})
      .then(function () { pending = false; });
  }

  function init() {
    var deb;
    var go = function () { clearTimeout(deb); deb = setTimeout(apply, 150); };
    function watch(node) {
      new MutationObserver(go).observe(node, { childList: true, subtree: true, characterData: true });
    }
    // Scope the observer to the Opus cart container so we don't react to the whole page.
    var container = document.querySelector('#cart-drawer-container');
    if (container) {
      watch(container);
    } else {
      // Opus mounts its drawer asynchronously; begin watching it once it appears.
      var bodyObs = new MutationObserver(function () {
        var c = document.querySelector('#cart-drawer-container');
        if (c) { bodyObs.disconnect(); watch(c); go(); }
      });
      bodyObs.observe(document.body, { childList: true, subtree: true });
    }
    go();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
